import ReactDOM from 'react-dom/client';

import App from './App';
import { applyTenantTheme } from './themes/apply-tenant-theme';
import { applyTheme } from './services/theme';

import './app.css';
import './themes/tenant-client1.css';

applyTenantTheme();
applyTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);
